import React, { Component } from 'react';
import '../../assets/AdminCss/ScrollableContent.css';
import WhatsAppButton from './WhatsAppButton';


class ScrollableContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      celebrities: [
        {
          id: 1,
          name: "Pulkit Samrat, Varun Sharma",
          description: "Bigshot",
          image: "/placeholder-images/celebrity1.jpg",
          videoUrl:"https://www.youtube.com/watch?v=3G6ylIHqyOw&list=PLND-S-nvxypykhCQX4jz6sxfbQA1SxHMQ",
          isPlaying: false
        },
        {
          id: 2,
          name: "Daisy Shah",
          description: "Bigshot",
          image: "/placeholder-images/celebrity2.jpg",
          videoUrl: null,
          isPlaying: false
        },
        {
          id: 3,
          name: "Randeep Hooda",
          description: "Bigshot",
          image: "/placeholder-images/celebrity3.jpg",
          videoUrl: null,
          isPlaying: false
        },
        {
          id: 4,
          name: "Krushna Abhishek",
          description: "BigShot",
          image: "/placeholder-images/celebrity4.jpg",
          videoUrl: null,
          isPlaying: false
        },
        {
          id: 5,
          name: "Boman Irani",
          description: "Bigshot",
          image: "/placeholder-images/celebrity5.jpg",
          videoUrl: null,
          isPlaying: false
        }
      ],
      providers: [
        { id: 1, name: "EZugi", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/15502.png" },
        { id: 2, name: "MAC88", logo: "https://tse2.mm.bing.net/th?id=OIP.E0F4xqF30zmCSaWPbTATUwHaEt&pid=Api&P=0&h=180" },
        { id: 3, name: "EZugi", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/15502.png" },
        { id: 4, name: "JILI", logo: "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=298,fit=crop,q=95/A1a1PR3o0rH480Bj/jili_logo-YD08lRRRZWTrDjPV.png" },
        { id: 5, name: "Royal Gaming", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/4223.png" },
        { id: 6, name: "Evolution Gaming", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/3273.png" },
        { id: 7, name: "QTech", logo: "https://dabba.b-cdn.net/kheloyaar360.net/banners/3275.png" },
        { id: 8, name: "MAC88", logo: "https://tse2.mm.bing.net/th?id=OIP.E0F4xqF30zmCSaWPbTATUwHaEt&pid=Api&P=0&h=180" }
      ]
    };
  }

  // Helper function to extract YouTube video ID
  getYoutubeId = (url) => {
    const regExp = /^.(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  // Toggle video play state
  toggleVideo = (celebrityId) => {
    const updatedCelebrities = this.state.celebrities.map(celebrity => {
      if (celebrity.id === celebrityId) {
        return { ...celebrity, isPlaying: !celebrity.isPlaying };
      } else {
        // Stop other videos from playing
        return { ...celebrity, isPlaying: false };
      }
    });
    
    this.setState({ celebrities: updatedCelebrities });
  }

  renderCelebrityCard(celebrity) {
    const videoId = celebrity.videoUrl ? this.getYoutubeId(celebrity.videoUrl) : null;
    
    return (
      <div className="celebrity-card" key={celebrity.id}>
        {celebrity.isPlaying && videoId ? (
          <div className="video-container">
            <iframe 
              width="100%" 
              height="100%" 
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`} 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
            <button 
              className="close-video-btn"
              onClick={() => this.toggleVideo(celebrity.id)}
            >
              Close
            </button>
          </div>
        ) : (
          <>
            <img 
              className="celebrity-img" 
              src={celebrity.image} 
              alt={celebrity.name} 
              loading="lazy"
            />
            <div className="celebrity-overlay">
              <div className="celebrity-name text-white">{celebrity.name} - {celebrity.description}</div>
              <div className="tag-row">
                <div className="k-tag">k</div>
                <div className="kheloyar-tag">Bigshot</div>
                <button className="subscribe-btn">Subscribe</button>
              </div>
            </div>
            {celebrity.videoUrl && (
              <div 
                className="play-btn" 
                onClick={() => this.toggleVideo(celebrity.id)}
              >
                <div className="play-icon"></div>
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  renderProviderCard(provider) {
    return (
      <div className="provider-card" key={provider.id}>
        <img className="provider-logo" src={provider.logo} loading="lazy" alt={provider.name} />
      </div>
    );
  }

  render() {
    return (
      <div className="scrollable-content">
        {/* Celebrities Section */}
        <div className="section-header">
          <div className="section-title">
            <div className="logo-icon"></div>
            <span className='text-white'>Celebrities</span>
          </div>
        </div>
        
        <div className="scroll-container celebrities">
          {this.state.celebrities.map(celebrity => this.renderCelebrityCard(celebrity))}
        </div>
        
        {/* Providers Section */}
        <div className="section-header">
          <div className="section-title">
            <div className="logo-icon provider-icon"></div>
            <span className='text-white'>Providers</span>
          </div>
          <a href="##" className="see-all">
            See All →
          </a>
        </div>
        
        <div className="scroll-container providers">
          {this.state.providers.map(provider => this.renderProviderCard(provider))}
        </div>
        
      <WhatsAppButton></WhatsAppButton>
      </div>
    );
  }
}

export default ScrollableContent;